import { useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { onKeyDownHandler } from 'helpers/ui.helper';
import { ELSIcon } from '..';
var MenuItem = function (_a) {
    var name = _a.name, paths = _a.paths, icon = _a.icon;
    return (<span key={name}>
    <Link className="c-button-menu__list-item" to={paths[0]}>
      {name}
      {icon && <ELSIcon name="new-window" size="1x"/>}
    </Link>
  </span>);
};
var ButtonMenu = function (_a) {
    var menuItems = _a.menuItems;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    return (<div className="c-button-menu">
      <div className={classNames('c-button-menu__button', { 'c-button-menu__button-active': open })} role="button" tabIndex={0} aria-expanded={open} aria-haspopup="menu" onKeyDown={function (evt) { return onKeyDownHandler(evt, function () { return setOpen(!open); }); }} onClick={function () { return setOpen(!open); }}>
        More...
      </div>
      {open && (<div className="c-button-menu__list-wrapper" onMouseLeave={function () { return setOpen(!open); }}>
          <div className="c-button-menu__list">
            {menuItems.map(function (item) { return (<MenuItem {...item} key={item.name}/>); })}
          </div>
        </div>)}
    </div>);
};
export { MenuItem };
export default ButtonMenu;
